import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const AiAssistant = ({ refs }) => {
    const aiAssistant = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.aiAssistant.description1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.aiAssistant.description2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.aiAssistant.description3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.mathConvertor}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'redesign.page.home.feature.aiAssistant.tag'}
                id={'section-aiAssistant'}
                img={`/static/asset/img/features/ai_assistant.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-aiAssistant-section'}
                title={'redesign.page.home.feature.aiAssistant.description'}
                explanations={aiAssistant}
            />
        </>
    );
};

export default AiAssistant;
